import React from "react";
import { Gauge, ShieldCheck, ShieldAlert, CalendarClock } from "lucide-react";
import Skeleton from "components/ui/Skeleton";

const UsageBar = ({ label, used, pct, limit }) => (
  <div>
    <div className="flex items-center justify-between mb-1.5">
      <span className="text-xs font-medium text-text_secondary">{label}</span>
      <span className="text-xs text-text_muted">
        {limit != null ? `${used.toLocaleString()} / ${limit.toLocaleString()}` : `${used.toLocaleString()} sent`}
      </span>
    </div>
    {pct != null && (
      <div className="w-full bg-surface_alt rounded-full h-1.5 overflow-hidden">
        <div
          className={`h-full rounded-full ${pct >= 90 ? "bg-danger" : pct >= 70 ? "bg-warning" : "bg-primary"}`}
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
    )}
  </div>
);

const QuotaCard = ({ quota, loading }) => {
  if (loading) {
    return (
      <div className="rounded-2xl border border-border bg-surface p-5">
        <Skeleton className="h-4 w-32 mb-4" />
        <Skeleton.Bars rows={2} />
      </div>
    );
  }

  if (!quota) {
    return (
      <div className="rounded-2xl border border-border bg-surface p-5 flex flex-col items-center justify-center text-center py-10">
        <ShieldAlert size={22} className="text-text_muted mb-2" />
        <p className="text-sm text-text_secondary">No active SendGrid credential</p>
        <p className="text-xs text-text_muted mt-1">Configure one under Email Settings.</p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-border bg-surface p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-semibold text-text_primary flex items-center gap-2">
          <Gauge size={16} className="text-text_muted" />
          Sending Quota
        </h2>
        <span className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full ${quota.is_domain_verified ? "bg-success_bg text-success" : "bg-warning_bg text-warning"}`}>
          <ShieldCheck size={11} />
          {quota.is_domain_verified ? "Domain verified" : "Unverified"}
        </span>
      </div>

      <div className="space-y-4">
        <UsageBar label="Daily limit" used={quota.sent_today} pct={quota.daily_usage_pct} limit={quota.per_day_limit} />
        <UsageBar label="Total plan limit" used={quota.total_sent} pct={quota.total_usage_pct} limit={quota.total_mail_limit} />
      </div>

      {quota.days_to_expiry != null && (
        <div className="mt-4 pt-4 border-t border-border flex items-center gap-2 text-xs text-text_secondary">
          <CalendarClock size={13} className="text-text_muted" />
          {quota.days_to_expiry >= 0
            ? `Plan expires in ${quota.days_to_expiry} day${quota.days_to_expiry === 1 ? "" : "s"}`
            : "Plan has expired"}
        </div>
      )}
    </div>
  );
};

export default QuotaCard;
